import { CustomerService } from '../../_services/customer.service';
import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http'; 
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { environment } from '../../../environments/environment';
import { APIURLS, SHAREDCONSTANTS, USERUPDATEVIEWLABELS, STATUS_OPTIONS_DEFAULT, STATUS_OPTIONS_VO } from '../../_constants/constants';
import { DEFAULT_OPCO, SPAIN, ITALY, GERMANY, UK, COUNTRY_CODE, ALL_COUNTRY_CODE } from '../../_constants/config';
import { Address, getUpdatePersonFromDetails, PersonDetails, PersonDetailsUpdate } from '../../_models/data.structures';
import { NotificationDialogComponent } from '../../notification/notification.dialog.component';
//import {IMyOptions, IMyInputFieldChanged} from '../../src/my-date-picker/interfaces';
import {IMyDpOptions, IMyInputFieldChanged} from 'mydatepicker';
import { TranslatePipe } from '../../shared/translate/translate.pipe';

export interface CustomerUpdateModel {
    title: string;
    previousData: PersonDetails;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'customer.update.dialog.component.html',
    providers: [TranslatePipe]
})


export class CustomerUpdateDialogComponent extends DialogComponent<CustomerUpdateModel, string> implements CustomerUpdateModel, OnInit {
    previousData: PersonDetails;
    title: string;
    person: PersonDetailsUpdate;
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
    userupdateviewlabels = USERUPDATEVIEWLABELS;
    userconfigfields = DEFAULT_OPCO;
    country_code = COUNTRY_CODE;
    all_country_codes:any = ALL_COUNTRY_CODE;
    countrycodeRange = [];
    genderTranslated = [];
    statusTranslated = {};
    citAccessTranslated = [];

    monthsTranslated:any = [];    
    dobDay: any = "";
    dobMonth: any = "0";
    dobYear: any = "";

    isDobError: boolean = false;
    dobErrorMsg = "";
    isGenderErr: boolean = false;
    isStatusErr: boolean = false;
    isCitAccessErr: boolean = false;
    isCountryErr: boolean = false;
    citaccessbooleanStatus:boolean=true;
    objectKeys = Object.keys;

    public model: any = null;

    constructor(private ds: DialogService, private translatePipe: TranslatePipe) {
        super(ds);
        this.genderTranslated = this.translatePipe.transform("GENDER_OPTIONS",'USERUPDATEVIEWLABELS');
        this.citAccessTranslated = this.translatePipe.transform("CIT_ACCESS_OPTIONS",'USERUPDATEVIEWLABELS');                     
    }

    private myDatePickerOptions: IMyDpOptions = {
        dateFormat: 'yyyy-mm-dd',
        height: '34px',
        width: '100%',
        inline: false,
        editableDateField: false,
        disableSince: {year: (new Date()).getFullYear(), month: (new Date()).getMonth()+1, day: (new Date()).getDate()+1}
    };

    apply() {
        this.close();
    }

    mouseHover(event) {

        event.target.setAttribute("title", "");        
    }

    ngOnInit(): void {
        

        this.isDobError = false;
        this.dobErrorMsg = "";
        this.statusTranslated = STATUS_OPTIONS_DEFAULT;
        if (this.opcoValue == 'vo') {
            this.statusTranslated = STATUS_OPTIONS_VO;
        }

        this.monthsTranslated = this.translatePipe.transform("CALENDAR_MONTHS", 'CALENDAR_SELECT_VALUES');        

        this.person = getUpdatePersonFromDetails(this.previousData);
        if (this.person.address === undefined) {
            this.person.address = new Address();
        }
      
        if( this.opcoValue === 'es' ){
            this.userconfigfields = SPAIN;
        }
        
        else if( this.opcoValue === 'de' ){
            this.userconfigfields = GERMANY;
        }
        
        else if( this.opcoValue === 'it' ){
            this.userconfigfields = ITALY;
        }
        
        else if( this.opcoValue === 'gb' ){
            this.userconfigfields = UK;
        }
        var dt = this.person.birthdate;
        if(dt){
            var a = (this.person.birthdate).split("-");
            this.model = {date: {year: parseInt(a[0]), month: parseInt(a[1]), day: parseInt(a[2])}};
            
            this.dobDay = a[2];
            this.dobMonth = a[1];
            this.dobYear = a[0];

            if (parseInt(this.dobMonth) >= 1 && parseInt(this.dobMonth) <= 9) {
                this.dobMonth = this.dobMonth.substring(1);
            }
        }
        for (let i = 0; i < this.country_code.country_code.length; i++) {
          this.countrycodeRange.push(i);
        }
    }

    changeMonth(e){

        this.isDobError = false;
        this.dobErrorMsg = "";
    }

    onlyNumber(e) {

        this.isDobError = false;
        this.dobErrorMsg = "";

        e = (e) ? e : window.event;
        var charCode = (e.which) ? e.which : e.keyCode;

        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+C
                (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+V
                (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
                // Allow: Ctrl+X
                (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        
        // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        //     return false;
        // }
        // return true;
    }

    isNumeric(str) {
        var pattern = /^\d+$/;
        return pattern.test(str);
    }

    onBlurDay(evt) {        
        let val = evt.target.value;

        if (parseInt(val) >= 1 && parseInt(val) <= 9) {
            if (val.length == 1){                
                this.dobDay = "0" + this.dobDay;
            }
        }
    }
    onChamgecit(data) {
        let val=data.toLowerCase() == 'true' ? true : false;
        this.citaccessbooleanStatus=val===this.previousData.citaccess?true:false;
        this.isCitAccessErr=false;
    }
    saveUserFormTask(formData: any) {
        this.isDobError = false;
        this.isGenderErr = false;
        this.isCountryErr = false;
        this.isStatusErr = false;
        this.isCitAccessErr = false;
        this.dobErrorMsg = "";
        if(this.opcoValue === 'vo'){
            if ((this.person.status !== null) && (this.person.status !== undefined)) {
                if (!this.statusTranslated.hasOwnProperty(this.person.status)) {
    
                    this.isStatusErr = true;                
                    return;
                }
                this.person.status = this.person.status;
            }
        }
        
        if(this.opcoValue === 'ro' || this.opcoValue === 'al' || this.opcoValue === 'cz' || this.opcoValue === 'it'){
            if ((this.person.status !== null) && (this.person.status !== undefined)) {
                if (!this.statusTranslated.hasOwnProperty(this.person.status)) {
    
                    this.isStatusErr = true;                
                    return;
                }
    
                this.person.status = this.person.status;
            }

            if ((this.person.citaccess !== null) && (this.person.citaccess !== undefined)) {
                /* if (!this.citAccessTranslated.hasOwnProperty(this.person.citaccess)) {
    
                    this.isCitAccessErr = true;                
                    return;
                } */
    
                this.person.citaccess = this.person.citaccess;
            }

        } else {
            if (this.userconfigfields.birthplace === "true" && (formData.form.controls['birthplace'] !== undefined) && ((this.person.birthplace === null) || (this.person.birthplace.trim() == "") || (this.person.birthplace === undefined))) {

                formData.form.controls['birthplace'].markAsDirty();
                formData.form.controls['birthplace'].markAsTouched();
                formData.form.controls['birthplace'].setErrors({ 'required': true });
                return;
    
            }

            if ((this.person.gender !== null) && (this.person.gender.trim() !== "") && (this.person.gender !== undefined)) {
                if (!this.genderTranslated.hasOwnProperty(this.person.gender)) {

                    this.isGenderErr = true;                
                    return;
                }
    
    // this.person.gender = this.person.gender.toLowerCase();
            }

            if ((this.person.address && this.person.address.country !== null) && (this.person.address.country !== undefined && this.person.address.country.trim() !== "") && (this.person.address.country !== undefined)) {
                        
                if (!(this.all_country_codes["country_codes"].indexOf(this.person.address.country.trim()) > -1)) {
    
                    this.isCountryErr = true;
                    return;
                }
            }

            if (this.dobYear != "" && this.dobDay != "") {

                if (this.dobMonth == "0"){
    
                    this.isDobError = true;
                    this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                    // this.ds.addDialog(NotificationDialogComponent, {
                    //     success: false,
                    //     message: this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                    // });
                    return;                                
                }
                else if (parseInt(this.dobYear) == 0 || parseInt(this.dobDay) == 0 || this.isNumeric(this.dobYear) === false || this.isNumeric(this.dobDay) === false) {
    
                    this.isDobError = true;
                    this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                    // this.ds.addDialog(NotificationDialogComponent, {
                    //     success: false,
                    //     message: this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                    // });
                    return;
                }            
                else{
    
                    let GivenDate = new Date(this.dobYear + "/" + this.dobMonth + "/" + this.dobDay);
                    let CurrentDate = new Date();  
                    let pastDate =new Date(new Date().setFullYear(new Date().getFullYear() - 100));
                    
                    if( GivenDate.toString()==="Invalid Date"){
                        this.isDobError = true;
                    this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                    
                    return;
                      }                       
    
                    if (GivenDate > CurrentDate) {
    
                        this.isDobError = true;
                        this.dobErrorMsg = this.translatePipe.transform("FUTURE_DOB_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                        // this.ds.addDialog(NotificationDialogComponent, {
                        //     success: false,
                        //     message: this.translatePipe.transform("FUTURE_DOB_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                        // });
                        return;
                    }
                    
                    if(GivenDate < pastDate){
                        this.isDobError = true;
                        this.dobErrorMsg = this.translatePipe.transform("BIRTHDATE_IS_TOO_OLD", 'API_ERROR');

                        return;
                    }
                   
    
                    if (parseInt(this.dobMonth) <= 9){
                        this.dobMonth = "0" + this.dobMonth;
                    }                
                    this.person.birthdate = this.dobYear + "-" + this.dobMonth + "-" + this.dobDay;
                }            
            }
            else if (this.dobMonth != "0" && (this.dobYear == "" || this.dobDay == "")) {
    
                this.isDobError = true;
                this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
    
                // this.ds.addDialog(NotificationDialogComponent, {
                //     success: false,
                //     message: this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                // });
                return; 
            }
            else if (this.dobDay != "" && (this.dobMonth == "0" || this.dobYear == "")) {
    
                this.isDobError = true;
                this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                // this.ds.addDialog(NotificationDialogComponent, {
                //     success: false,
                //     message: this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                // });
                return;
            }
            else if (this.dobYear != "" && (this.dobMonth == "0" || this.dobDay == "")) {
    
                this.isDobError = true;
                this.dobErrorMsg = this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR');
    
                // this.ds.addDialog(NotificationDialogComponent, {
                //     success: false,
                //     message: this.translatePipe.transform("INVALID_DATE_ERROR", 'CLIENT_SIDE_VALIDATION_ERROR')
                // });
                return;
            }        
            else{
                this.person.birthdate = "";
            }
        }
        this.customerService.saveUpdatedUser(this.person, this.subValue, this.opcoValue, this.ds);
      this.close();
    }


    onInputFieldChanged(event: IMyInputFieldChanged) {
        //console.log('onInputFieldChanged(): Value: ', event.value, ' - dateFormat: ', event.dateFormat, ' - valid: ', event.valid);
        this.person.birthdate = event.value;
    }
}




// WEBPACK FOOTER //
// ./src/app/details/customer-update/customer.update.dialog.component.ts